// @flow

import styled from 'styled-components';
import { MEDIUM } from '../../../helpers/fontWeight';
import type { Theme } from '../../../types';

export const Title = styled<any, Theme>('h2')`
  font-size: 1.75rem;
  margin: 0 0 1rem 0;
  width: 100%;
  text-align: center;
`;

export const Button = styled<any, Theme>('button')`
  background: none;
  border: none;
  color: ${props => props.theme.modal.closeButton.main};
  cursor: pointer;
  flex-grow: 1;
  font-size: ${props => props.theme.modal.fontSize};
  font-weight: ${MEDIUM};
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;

  &:hover {
    color: ${props => props.theme.modal.closeButton.hover};
  }

  i {
    margin: 0 0 0 .25rem;
    font-size: 1rem;
    &:before {
      vertical-align: bottom;
    }
  }
`;

export default styled<any, Theme>('header')`
  align-items: flex-end;
  background: ${props => props.theme.modal.backgroundColor};
  border-radius: ${props => `${props.theme.modal.borderRadius} ${props.theme.modal.borderRadius} 0 0`};
  color: ${props => props.theme.modal.headerColor};
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap-reverse;
  padding: 2rem 2rem 0;
`;
